import type { DashboardChartColorScheme } from '@pm-next/shared-types';
import { DASHBOARD_CHART_COLOR_SCHEMES } from '@pm-next/shared-types';

const THEME_COLORS = [
  'hsl(var(--chart-1))',
  'hsl(var(--chart-2))',
  'hsl(var(--chart-3))',
  'hsl(var(--chart-4))',
  'hsl(var(--chart-5))',
  'hsl(var(--primary))',
  'hsl(var(--muted-foreground))',
];

const FALLBACK_DEFAULT = [
  '#3b82f6',
  '#10b981',
  '#f59e0b',
  '#ef4444',
  '#8b5cf6',
  '#ec4899',
  '#6b7280',
];

const PALETTES: Record<string, string[]> = {
  [DASHBOARD_CHART_COLOR_SCHEMES.default]: FALLBACK_DEFAULT,
  [DASHBOARD_CHART_COLOR_SCHEMES.pastel]: [
    '#a5b4fc',
    '#86efac',
    '#fcd34d',
    '#f9a8d4',
    '#67e8f9',
    '#fdba74',
    '#c4b5fd',
  ],
  [DASHBOARD_CHART_COLOR_SCHEMES.vivid]: [
    '#2563eb',
    '#16a34a',
    '#ea580c',
    '#dc2626',
    '#7c3aed',
    '#db2777',
    '#0891b2',
  ],
  [DASHBOARD_CHART_COLOR_SCHEMES.mono]: [
    '#111827',
    '#374151',
    '#4b5563',
    '#6b7280',
    '#9ca3af',
    '#d1d5db',
    '#e5e7eb',
  ],
  [DASHBOARD_CHART_COLOR_SCHEMES.cool]: [
    '#0ea5e9',
    '#06b6d4',
    '#14b8a6',
    '#6366f1',
    '#8b5cf6',
    '#3b82f6',
    '#22d3ee',
  ],
  [DASHBOARD_CHART_COLOR_SCHEMES.warm]: [
    '#ef4444',
    '#f97316',
    '#f59e0b',
    '#eab308',
    '#ec4899',
    '#f43f5e',
    '#fb7185',
  ],
};

export const CHART_COLOR_SCHEME_OPTIONS: Array<{ id: DashboardChartColorScheme; label: string }> = [
  { id: DASHBOARD_CHART_COLOR_SCHEMES.default, label: 'Default' },
  { id: DASHBOARD_CHART_COLOR_SCHEMES.pastel, label: 'Pastel' },
  { id: DASHBOARD_CHART_COLOR_SCHEMES.vivid, label: 'Vivid' },
  { id: DASHBOARD_CHART_COLOR_SCHEMES.mono, label: 'Mono' },
  { id: DASHBOARD_CHART_COLOR_SCHEMES.cool, label: 'Cool' },
  { id: DASHBOARD_CHART_COLOR_SCHEMES.warm, label: 'Warm' },
];

export function resolveChartColors(scheme?: DashboardChartColorScheme | null): string[] {
  const id = scheme || DASHBOARD_CHART_COLOR_SCHEMES.default;
  if (id === DASHBOARD_CHART_COLOR_SCHEMES.default) {
    try {
      if (
        typeof getComputedStyle !== 'undefined' &&
        getComputedStyle(document.documentElement).getPropertyValue('--chart-1')
      ) {
        return THEME_COLORS;
      }
    } catch {
      // ignore
    }
  }
  return PALETTES[id] ?? PALETTES[DASHBOARD_CHART_COLOR_SCHEMES.default]!;
}
